module.exports = {"name":"Shatter Seguridad","addresses":[{"address":"Cra 24 # 5-51 Barrio/ Alameda","city":"Cali","country":"Colombia"},{"address":"Calle 75 # 23 - 54 Barrio/ Alcázares Norte","city":"Bogota","country":"Colombia"}],"phones":[{"label":"Cali","value":"514 77 00"},{"label":"Bogota","value":"(051) 346 42 26"}],"emails":[{"label":"Servicio al Cliente","value":"solucionesoportunas@seguridadshatter.com"}],"website":"https://seguridadshatter.com"}


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shatter/shatterinfo.json
// module id = 322
// module chunks = 1